/** Traductions modale catalogue (FR / AR) */
export const catalogPageFr = {
  noItemsToDownload: 'Aucun élément dans le catalogue à télécharger',
  invalidProductsFound: '{{count}} produits non valides trouvés. Veuillez les corriger d\'abord.',
  downloadSuccess: '{{count}} produits valides téléchargés avec succès',
  readingFile: 'Lecture du fichier en cours...',
  invalidCsv: 'Fichier CSV invalide',
  processingData: 'Traitement des données en cours...',
  validatingData: 'Validation des données en cours...',
  dataReadyForReview: 'Données préparées pour révision',
  fileReadError: 'Erreur lors de la lecture du fichier',
  importStarting: 'Démarrage de l\'importation...',
  importPrepared: '{{count}} éléments préparés pour l\'importation...',
  importSuccess: '{{count}} éléments importés avec succès',
  importError: 'Erreur lors de l\'importation',
  itemDeletedSuccess: 'Élément supprimé avec succès',
  selectAtLeastOne: 'Veuillez sélectionner au moins un élément',
  bulkDeleteSuccess: '{{count}} éléments supprimés avec succès',
  addedToInventory: '{{count}} éléments ajoutés à l\'inventaire',
  addedToPurchase: '{{count}} éléments ajoutés à l\'achat',
  functionUnavailable: 'Fonction non disponible',
  imageUpdatedSuccess: 'Image mise à jour avec succès',
  imageDeletedSuccess: 'Image supprimée avec succès',
  validProductsKept: '{{count}} produits valides conservés uniquement',
  title: 'Gestion du Catalogue',
  supermarket: 'Supermarket',
  aman: 'Aman',
  downloadTemplate: 'Télécharger Template',
  importFile: 'Importer Fichier',
  addToInventory: 'Ajouter à l\'Inventaire ({{count}})',
  addToPurchase: 'Ajouter à l\'Achat ({{count}})',
  deleteSelected: 'Supprimer sélectionnés ({{count}})',
  searchPlaceholder: 'Rechercher dans le catalogue...',
  allCategories: 'Toutes les catégories',
  allSuppliers: 'Tous les fournisseurs',
  sortName: 'Nom (A-Z)',
  sortCategory: 'Catégorie',
  sortPrice: 'Prix',
  selectAll: 'Sélectionner tout',
  unitLabel: 'Unité:',
  pickingLabel: 'Cueillette:',
  supplierLabel: 'Fournisseur:',
  quantityLabel: 'Quantité:',
  priceLabel: 'Prix:',
  purchasePriceLabel: 'Prix achat:',
  locationLabel: 'Emplacement:',
  colImage: 'Image',
  colSku: 'SKU',
  colName: 'Nom',
  colCategory: 'Catégorie',
  colSupplier: 'Fournisseur',
  colQuantity: 'Quantité',
  colPrice: 'Prix',
  colUnit: 'Unité',
  colPicking: 'Cueillette',
  colConservation: 'Conservation',
  colLocation: 'Emplacement',
  colActions: 'Actions',
  change: 'Changer',
  na: 'N/D',
  emptyCatalog: 'Aucun élément dans le catalogue',
  paginationShowing: 'Affichage de {{start}}-{{end}} sur {{total}} éléments',
  itemsUnit: 'éléments',
  first: 'Première',
  previous: 'Précédente',
  next: 'Suivante',
  last: 'Dernière',
  pageOf: 'Page {{current}} sur {{total}}',
  importPreview: 'Aperçu de l\'importation',
  pleaseWait: 'Veuillez patienter, cela peut prendre quelques instants...',
  processing: 'Traitement en cours...',
  validCount: 'Valides',
  invalidCount: 'Invalides',
  duplicateCount: 'Doublons',
  duplicateActionLabel: 'Action pour les doublons:',
  skipDuplicates: 'Ignorer (empêcher duplication)',
  replaceCatalogOnly: 'Remplacer (catalogue seulement)',
  inventoryReplaceNote: 'Note: Les éléments existants dans l\'inventaire ne peuvent pas être remplacés',
  errorDetails: 'Détails des erreurs:',
  rowLabel: 'Ligne {{row}}:',
  nameLabel: 'Nom:',
  statusInInventory: 'Dans inventaire',
  statusInCatalog: 'Dans catalogue',
  cancel: 'Annuler',
  importing: 'Importation...',
  import: 'Importer',
  imageManagement: 'Gestion de l\'image du produit',
  currentImage: 'Image actuelle:',
  chooseNewImage: 'Choisir une nouvelle image:',
  chooseFile: 'Choisir un fichier',
  newImagePreview: 'Aperçu de la nouvelle image:',
  deleteImage: 'Supprimer l\'image',
  apply: 'Appliquer',
  confirmDelete: 'Confirmer la suppression',
  deleteSelectedItems: 'Supprimer les éléments sélectionnés',
  deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer {{count}} éléments ?',
  deleteWarning: 'Attention : Cette action ne peut pas être annulée !',
  deleteWarningDetail: 'Tous les éléments sélectionnés seront définitivement supprimés du catalogue.',
  deletePermanently: 'Supprimer définitivement',
  colStatus: 'Statut',
  unknownSupplier: 'Fournisseur inconnu'
};

export const catalogPageAr = {
  noItemsToDownload: 'لا توجد عناصر في الكتالوج للتحميل',
  invalidProductsFound: 'تم العثور على {{count}} منتج غير صالح. يرجى تصحيحها أولاً.',
  downloadSuccess: 'تم تحميل {{count}} منتج صالح بنجاح',
  readingFile: 'جاري قراءة الملف...',
  invalidCsv: 'ملف CSV غير صالح',
  processingData: 'جاري معالجة البيانات...',
  validatingData: 'جاري التحقق من صحة البيانات...',
  dataReadyForReview: 'تم تحضير البيانات للمراجعة',
  fileReadError: 'خطأ في قراءة الملف',
  importStarting: 'جاري بدء عملية الاستيراد...',
  importPrepared: 'تم تحضير {{count}} عنصر للاستيراد...',
  importSuccess: 'تم استيراد {{count}} عنصر بنجاح',
  importError: 'حدث خطأ أثناء الاستيراد',
  itemDeletedSuccess: 'تم حذف العنصر بنجاح',
  selectAtLeastOne: 'يرجى اختيار عنصر واحد على الأقل',
  bulkDeleteSuccess: 'تم حذف {{count}} عنصر بنجاح',
  addedToInventory: 'تم إضافة {{count}} عنصر للمخزون',
  addedToPurchase: 'تم إضافة {{count}} عنصر للشراء',
  functionUnavailable: 'وظيفة غير متاحة',
  imageUpdatedSuccess: 'تم تحديث الصورة بنجاح',
  imageDeletedSuccess: 'تم حذف الصورة بنجاح',
  validProductsKept: 'تم الاحتفاظ بـ {{count}} منتج صالح فقط',
  title: 'إدارة الكتالوج',
  supermarket: 'سوبر ماركت',
  aman: 'أمان',
  downloadTemplate: 'تحميل القالب',
  importFile: 'استيراد ملف',
  addToInventory: 'إضافة للمخزون ({{count}})',
  addToPurchase: 'إضافة للشراء ({{count}})',
  deleteSelected: 'حذف المحدد ({{count}})',
  searchPlaceholder: 'البحث في الكتالوج...',
  allCategories: 'جميع الفئات',
  allSuppliers: 'جميع الموردين',
  sortName: 'الاسم (أ-ي)',
  sortCategory: 'الفئة',
  sortPrice: 'السعر',
  selectAll: 'تحديد الكل',
  unitLabel: 'الوحدة:',
  pickingLabel: 'القطف:',
  supplierLabel: 'المورد:',
  quantityLabel: 'الكمية:',
  priceLabel: 'السعر:',
  purchasePriceLabel: 'سعر الشراء:',
  locationLabel: 'الموقع:',
  colImage: 'صورة',
  colSku: 'SKU',
  colName: 'الاسم',
  colCategory: 'الفئة',
  colSupplier: 'المورد',
  colQuantity: 'الكمية',
  colPrice: 'السعر',
  colUnit: 'الوحدة',
  colPicking: 'القطف',
  colConservation: 'الحفظ',
  colLocation: 'الموقع',
  colActions: 'الإجراءات',
  change: 'تغيير',
  na: 'بدون',
  emptyCatalog: 'لا توجد عناصر في الكتالوج',
  paginationShowing: 'عرض {{start}}-{{end}} من {{total}} عنصر',
  itemsUnit: 'عنصر',
  first: 'الأولى',
  previous: 'السابقة',
  next: 'التالية',
  last: 'الأخيرة',
  pageOf: 'صفحة {{current}} من {{total}}',
  importPreview: 'معاينة الاستيراد',
  pleaseWait: 'يرجى الانتظار، قد يستغرق هذا بعض الوقت...',
  processing: 'جاري المعالجة...',
  validCount: 'صالح',
  invalidCount: 'غير صالح',
  duplicateCount: 'مكرر',
  duplicateActionLabel: 'إجراء للعناصر المكررة:',
  skipDuplicates: 'تخطي (منع التكرار)',
  replaceCatalogOnly: 'استبدال (في الكتالوج فقط)',
  inventoryReplaceNote: 'ملاحظة: لا يمكن استبدال العناصر الموجودة في المخزون',
  errorDetails: 'تفاصيل الأخطاء:',
  rowLabel: 'السطر {{row}}:',
  nameLabel: 'الاسم:',
  statusInInventory: 'في المخزون',
  statusInCatalog: 'في الكتالوج',
  cancel: 'إلغاء',
  importing: 'جاري الاستيراد...',
  import: 'استيراد',
  imageManagement: 'إدارة صورة المنتج',
  currentImage: 'الصورة الحالية:',
  chooseNewImage: 'اختر صورة جديدة:',
  chooseFile: 'اختر ملف',
  newImagePreview: 'معاينة الصورة الجديدة:',
  deleteImage: 'حذف الصورة',
  apply: 'تطبيق',
  confirmDelete: 'تأكيد الحذف',
  deleteSelectedItems: 'حذف العناصر المحددة',
  deleteConfirmMessage: 'هل أنت متأكد من أنك تريد حذف {{count}} عنصر؟',
  deleteWarning: 'تحذير: لا يمكن التراجع عن هذا الإجراء!',
  deleteWarningDetail: 'سيتم حذف جميع العناصر المحددة نهائياً من الكتالوج.',
  deletePermanently: 'حذف نهائي',
  colStatus: 'الحالة',
  unknownSupplier: 'مورد غير معروف'
};
